import { createApp } from 'vue'
import router from '../v2/style-guide/routes'
import StyleGuideApp from "../v2/style-guide/StyleGuideApp.vue";
import Popper from "vue3-popper";
import AppUtil from "../app/utils/AppUtil";
import UIUtil from "../app/utils/UIUtil";
import ColorUtil from "../app/utils/ColorUtil";
import ThemeUtil from "../app/utils/ThemeUtil";
import FontUtil from "../app/utils/FontUtil";
import Rails from "@rails/ujs";
window.Rails = Rails
import webase from "../v2/style-guide/model"
window.webase = webase
import styleMap from "../assets/category-map.json"
window.webaseStyleMap = styleMap
import FlexContainer from "../v2/component-types/FlexContainer.vue";
import GridContainer from "../v2/component-types/GridContainer.vue";
import ColumnsContainer from "../v2/component-types/ColumnsContainer.vue";
import ButtonComponent from "../v2/component-types/ButtonComponent.vue";

webase.utils.app = new AppUtil()
console.log('WeBase style guide app')
console.log(webase.utils.app)
webase.utils.ui = new UIUtil()
webase.utils.color = new ColorUtil()
webase.utils.theme = new ThemeUtil()
webase.utils.font = new FontUtil()

document.addEventListener('DOMContentLoaded', () => {
    const app = createApp(StyleGuideApp)
    app.use(router)
    app.component("Popper", Popper)
    app.component('FlexContainer', FlexContainer)
    app.component('GridContainer', GridContainer)
    app.component('ColumnsContainer', ColumnsContainer)
    app.component('ButtonComponent', ButtonComponent)
    app.mount('#style-guide')
})
